import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import UserCard from '@components/ConnectionCard';
import CommunityActions from '~/actions/community';

const SentRequests = ({ user, requests }) => {
    const dispatch = useDispatch();

    const handleDismiss = (connection) => () => {
        const payload = {
            data: { payload: { connection_id: connection.id }, action: 'delete' },
            after: { type: 'GETCOMMUNITYCONNECTIONS_REQUEST', payload: { user_id: user.id } },
        };
        dispatch(CommunityActions.postconnectionupdateRequest(payload));
    };

    const handleOpenDetail = (connect) => () => {
        const { user_id, slug } = connect.connector;
        dispatch(CommunityActions.getcommunityuserRequest({ userId: user_id }, null, `/${slug}/about`));
    };

    return (
        <Row className="connections-received-request mx-1">
            {requests.map((connection) => (
                <Col key={connection.id} className="p-2" xs={12} sm={6} md={3}>
                    <UserCard tab="sent" data={connection} onClick={handleDismiss(connection)} onOpen={handleOpenDetail(connection)} />
                </Col>
            ))}
        </Row>
    );
};

SentRequests.propTypes = {
    user: PropTypes.shape({ id: PropTypes.number }),
    requests: PropTypes.array,
};

SentRequests.defaultProps = {
    user: { id: 0 },
    requests: [],
};

export default SentRequests;
